import React, { FC, Fragment } from 'react';
import { Menu, Layout, Avatar, Popover, Badge, List } from 'antd';
import { BellOutlined, RightOutlined, MenuFoldOutlined, MenuUnfoldOutlined, UserOutlined } from '@ant-design/icons';
import classnames from 'classnames';
import dayjs from 'dayjs';
import { config } from '@app/utils';
import { ThemesEnum } from '@app/modules/Auth';
import Ellipsis from '../Ellipsis';
import './Header.less';

const { SubMenu } = Menu;

declare type Notification = {
  title: string;
  date: Date;
};

interface HeaderPropsInterface {
  fixed: boolean;
  theme: ThemesEnum;
  username: any;
  menus: any[];
  collapsed: boolean;
  onSignOut: () => void;
  notifications: Notification[];
  onCollapseChange: (collapse: boolean) => void;
  onAllNotificationsRead: () => void;
  avatar?: string; // @todo add anything
}

export const Header: FC<HeaderPropsInterface> = ({
  fixed,
  theme,
  menus,
  username,
  collapsed,
  notifications,
  onSignOut,
  onCollapseChange,
  onAllNotificationsRead,
  avatar = ''
}) => {
  const handleClickMenu = e => {
    e.key === 'SignOut' && onSignOut();
  };

  const rightContent = [
    <Menu theme={theme} key="user" mode="horizontal" onClick={handleClickMenu} triggerSubMenuAction="hover">
      <SubMenu
        key="sub"
        title={
          <Fragment>
            <span style={{ color: '#999', marginRight: 4 }}>Hi,</span>
            <span>{username}</span>
            <Avatar style={{ marginLeft: 8 }} icon={<UserOutlined />} src={avatar} />
          </Fragment>
        }
      >
        <Menu.Item key="SignOut">Sign out</Menu.Item>
      </SubMenu>
    </Menu>
  ];

  if (config.i18n) {
    const { languages, defaultLanguage } = config.i18n;
    // @ts-ignore
    const currentLanguage: { key: string; title: string; flag: string } = languages.find(
      item => item.key === defaultLanguage
    );

    rightContent.unshift(
      <Menu
        theme={theme}
        key="language"
        selectedKeys={[currentLanguage.key]}
        onClick={data => {
          console.log({ setLocale: data.key });
        }}
        mode="horizontal"
      >
        <SubMenu key="languages" title={<Avatar size="small" src={currentLanguage.flag} />}>
          {languages.map(item => (
            <Menu.Item key={item.key}>
              <Avatar size="small" style={{ marginRight: 8 }} src={item.flag} />
              {item.title}
            </Menu.Item>
          ))}
        </SubMenu>
      </Menu>
    );
  }

  rightContent.unshift(
    <Popover
      placement="bottomRight"
      trigger="click"
      key="notifications"
      overlayClassName="notificationPopover"
      getPopupContainer={() => document.querySelector('#primaryLayout') as HTMLElement}
      content={
        <div className="notification">
          <List
            itemLayout="horizontal"
            dataSource={notifications}
            locale={{
              emptyText: 'You have viewed all notifications.'
            }}
            renderItem={item => (
              <List.Item className="notificationItem">
                <List.Item.Meta
                  title={
                    <Ellipsis tooltip lines={1}>
                      {item.title}
                    </Ellipsis>
                  }
                  description={dayjs(item.date).fromNow()}
                />
                <RightOutlined style={{ fontSize: 10, color: '#ccc' }} />
              </List.Item>
            )}
          />
          {notifications.length ? (
            <div onClick={onAllNotificationsRead} className="clearButton">
              Clear notifications
            </div>
          ) : null}
        </div>
      }
    >
      <Badge count={notifications.length} dot offset={[-10, 10]} className="iconButton">
        <BellOutlined className="iconFont" />
      </Badge>
    </Popover>
  );

  return (
    <Layout.Header
      className={classnames('header', {
        fixed,
        collapsed
      })}
      id="layoutHeader"
    >
      <div className="button" onClick={() => onCollapseChange(!collapsed)}>
        {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
      </div>
      <div className="rightContainer">{rightContent}</div>
    </Layout.Header>
  );
};
